export const ROOM_JOIN_TYPE = {
    ENTER_ROOM: "enter room",
    CREATE_ROOM: "create meeting"
};
